import BaseUseCase from "../../../base_use_case.js.jsx";

class LoadNewsletterEmailsUseCase extends BaseUseCase {

  execute() {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/newsletter/emails`,
    });
  }
}

const instance = new LoadNewsletterEmailsUseCase();
export default instance;
